import { FormSelectId, FormSelectIdProps } from '@nexelem/form-components';
import { useCustomTranslation } from '../../../hooks';
import { useProductGroups } from '../../../queryHooks/useProductGroups';

type FormGroupSelectProps = Omit<FormSelectIdProps, 'label' | 'options' | 'placeholder'>;

export const FormGroupSelect = (props: FormGroupSelectProps) => {
  const { t, tWrapper } = useCustomTranslation('warehouse.outboundDeliveries.filters');
  const { data, isLoading } = useProductGroups();

  const options = data?.map(({ id, name }) => {
    return { id, label: name };
  });

  return (
    <FormSelectId
      {...props}
      label={tWrapper('group')}
      loading={isLoading}
      options={options}
      placeholder={t('components.filters.searchOrSelect')}
    />
  );
};
